import { useEffect } from "./jsx.js";
const loaded = [];
export function Script({ src, onReload }) {
    useEffect(() => {
        if (loaded.indexOf(src) >= 0) {
            if (onReload) {
                onReload();
            }
            return;
        }
        loaded.push(src);
        const script = document.createElement("script");
        script.src = src;
        script.async = true;
        document.head.appendChild(script);
    }, [0]);
    return null;
}
